/* global requestAnimationFrame, setTimeout */
// Toast minimalista, sem dependências, usando as CSS vars do tema.
let container;

function ensureContainer() {
  if (container) return container;
  container = document.createElement('div');
  container.style.cssText =
    'position:fixed;top:16px;right:16px;z-index:9999;display:flex;flex-direction:column;gap:8px;pointer-events:none;';
  document.body.appendChild(container);
  return container;
}

export function toast(message, kind = 'success') {
  const c = ensureContainer();
  const el = document.createElement('div');
  const color = kind === 'error' ? 'var(--danger)' : kind === 'warning' ? 'var(--warning)' : 'var(--success)';
  el.textContent = message;
  el.style.cssText = `
    pointer-events:auto;min-width:220px;max-width:360px;padding:12px 16px;border-radius:10px;
    background:var(--surface-elevated);color:var(--text);font-size:13px;font-weight:600;
    border:1px solid var(--border);border-left:3px solid ${color};
    box-shadow:0 8px 24px rgba(0,0,0,.25);opacity:0;transform:translateX(20px);
    transition:opacity .2s,transform .2s;`;
  c.appendChild(el);
  requestAnimationFrame(() => {
    el.style.opacity = '1';
    el.style.transform = 'translateX(0)';
  });
  setTimeout(() => {
    el.style.opacity = '0';
    el.style.transform = 'translateX(20px)';
    setTimeout(() => el.remove(), 250);
  }, 3200);
}

// Açúcar sintático: suporta tanto `toast(msg, 'success')` quanto `toast.success(msg)`.
// Vários componentes usam a forma encadeada (Gamificação, MonitorWorker, Contas, Cartões).
toast.success = (message) => toast(message, 'success');
toast.error = (message) => toast(message, 'error');
toast.warning = (message) => toast(message, 'warning');
toast.info = (message) => toast(message, 'info');
